import React from 'react'
import FirebaseLogin from '../../components/auth/FirebaseLogin'
import AuthLayout from '../../components/layout/AuthLayout'
import { UserRole } from '../../models/UserProfile'

const Login = () => {
  return (
    <AuthLayout>
      <FirebaseLogin role={UserRole.school} title="School Login" />
    </AuthLayout>
  )
}

export default Login
